import React from 'react'
import { useAuth } from '../../context/AuthContext'
import { useTheme } from '../../context/ThemeContext'

// ── Icon constants ────────────────────────────────────────────────────────────

const SEARCH_ICON = (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="7"/>
    <path d="m21 21-4.35-4.35"/>
  </svg>
)

const SUN_ICON = (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="4"/>
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>
  </svg>
)

const MOON_ICON = (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
)

const BELL_ICON = (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
  </svg>
)

// ── Component ─────────────────────────────────────────────────────────────────

export default function Header() {
  const { user } = useAuth()
  const { isDark, toggleTheme } = useTheme()

  const initials = user?.name
    ? user.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
    : 'U'

  return (
    <div className="topbar">

      {/* Search */}
      <div className="topbar-search">
        {SEARCH_ICON}
        <span style={{ flex: 1, fontSize: 13, color: 'var(--text-faint)' }}>Search…</span>
        <span style={{ display: 'flex', gap: 2 }}>
          <span className="ds-kbd">⌘</span>
          <span className="ds-kbd">K</span>
        </span>
      </div>

      <div className="topbar-right">

        {/* Theme toggle */}
        <button
          className="ds-btn ds-btn-icon ds-btn-ghost"
          onClick={toggleTheme}
          title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {isDark ? SUN_ICON : MOON_ICON}
        </button>

        {/* Notifications */}
        <button
          className="ds-btn ds-btn-icon ds-btn-ghost"
          title="Notifications"
          style={{ position: 'relative' }}
        >
          {BELL_ICON}
          <span style={{
            position: 'absolute',
            top: 7,
            right: 7,
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: 'var(--accent)',
          }} />
        </button>

        <div className="vdiv" style={{ height: 18, margin: '0 4px' }} />

        {/* User */}
        <button className="topbar-user">
          <div className="ds-avatar ds-avatar-1" style={{ width: 30, height: 30, fontSize: 11 }}>
            {initials}
          </div>
          <div style={{ textAlign: 'left' }}>
            <div className="user-name">{user?.name || 'User'}</div>
            <div className="user-sub">{user?.role === 'admin' ? 'Admin' : 'Client'}</div>
          </div>
        </button>

      </div>
    </div>
  )
}
